import analysisSdk from '@hetao/analysis-web-sdk';
import { environment, getTagName } from './environment';
import { version } from '../../package.json';

window.analysisSdk = analysisSdk;

window.hetaoTrack = function (eventName: string, props = {}) {
  window.analysisSdk.track(eventName, {
    context: {
      ...props,
      contest: {
        htContestTag: getTagName(),
        cookieId: null,
        // contestName: contestName, //老赛事系统中需要的参数，新系统已经没有这个参数了
        projectName: 'ug-fe-contest-student',
      },
    },
  });
};

analysisSdk.init({
  env: 'production', // environment === 'production' ? 'production' : 'testing', //当前的环境testing  or  production
  version: version, // 埋点项目版本，实际值使用客户端开发迭代的版本，即埋点版本和客户端版本保持一致
  // userId:"55090", //用户的id 没有userId时可不传，等后续获取到userId后 通过update方法传入
  // userId: analysisSdk.getUUID(),
  product: 'contest', // 赛事系统

  // optional
  sensors: true, //是否第三方神策 可以不传 默认为true
  inside: true, //是否调用数仓 可以不传 默认为true
  logs: environment === 'production' ? false : true, //是否打印log********s
  geolocation: {
    // 表示当前的经纬度，如果传入，sdk中则不自动获取
    latitude: '',
    longitude: '',
  },
  //数仓埋点地址， 内置地址如下, 如果确认使用此地址，则不需要指定envUrl
  //  testing: "http://datacenter.testing.hetao101.com/app/eventdata/transfer/v1",
  //    production: "https://datacenter.hetao101.com/app/eventdata/transfer/v1"
  envUrl: 'https://datacenter.hetao101.com/app/eventdata/transfer/v1',
});
